module.exports = __webpack_public_path__ + "img/Perks-Coming-soon.e6ccd246.png";